module.exports = __webpack_public_path__ + "static/img/manual-32.824df6e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-32.png
// module id = W+fJ
// module chunks = 4